/**
 * DialerAuthContext — refactor 2026-06-04 (Fowler audit 4/3).
 *
 * Decoupe partielle du DialerContext : extrait les states d'auth du caller
 * (callerData, needsLogin, isLoggingOut) dans leur propre Provider. Premier
 * pas vers un decoupage thematique complet (Auth / Queries / UI / Handlers)
 * recommande par Fowler.
 *
 * Pourquoi seulement Auth pour ce sprint :
 *  - Le plus simple a extraire (3 states + 0 side effect)
 *  - Aucun consommateur ne casse : DialerContext.useDialer() continue de
 *    re-exposer ces props via sa facade
 *  - Les autres extractions (Queries, UI, Handlers) ont 30+ deps croisees,
 *    necessitent un sprint dedie
 *
 * Les consommateurs externes peuvent maintenant utiliser useDialerAuth()
 * au lieu de useDialer().callerData s'ils ne veulent que l'auth. Reduit
 * les re-renders inutiles (changement de prospectQueue ne re-rend pas un
 * composant qui n'a besoin que de callerData).
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useContext, useState } from 'react';

export interface DialerAuthValue {
  callerData: any | null;
  setCallerData: (v: any | null) => void;
  needsLogin: boolean;
  setNeedsLogin: (v: boolean) => void;
  isLoggingOut: boolean;
  setIsLoggingOut: (v: boolean) => void;
}

const DialerAuthContext = createContext<DialerAuthValue | null>(null);

export function DialerAuthProvider({ children }: { children: React.ReactNode }) {
  const [callerData, setCallerData] = useState<any | null>(null);
  const [needsLogin, setNeedsLogin] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const value: DialerAuthValue = {
    callerData,
    setCallerData,
    needsLogin,
    setNeedsLogin,
    isLoggingOut,
    setIsLoggingOut,
  };

  return <DialerAuthContext.Provider value={value}>{children}</DialerAuthContext.Provider>;
}

export function useDialerAuth(): DialerAuthValue {
  const v = useContext(DialerAuthContext);
  if (!v) throw new Error('useDialerAuth must be used within DialerAuthProvider');
  return v;
}
